import { render, staticRenderFns } from "./ClientOverview_EditClient.vue?vue&type=template&id=e2751514&scoped=true&"
import script from "./ClientOverview_EditClient.vue?vue&type=script&lang=js&"
export * from "./ClientOverview_EditClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2751514",
  null
  
)

export default component.exports